import { render, staticRenderFns } from "./videoComponent.vue?vue&type=template&id=db622f62&scoped=true&"
import script from "./videoComponent.vue?vue&type=script&lang=js&"
export * from "./videoComponent.vue?vue&type=script&lang=js&"
import style0 from "./videoComponent.vue?vue&type=style&index=0&id=db622f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db622f62",
  null
  
)

export default component.exports